import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["input"]

  onSubmit(e) {
    e.target.disabled = true

    let data = new FormData()
    this.inputTargets.map((inputTarget) => {
      let value = null
      if (inputTarget.nodeName == "INPUT" || inputTarget.nodeName == "TEXTAREA") {
        value = inputTarget.value
      } else if (inputTarget.nodeName == "SELECT") {
        value = Array.from(inputTarget.options).map((x) => x.value);
      }
      if (Array.isArray(value)) {
        value.map((item) => data.append(inputTarget.name, item))
      } else {
        data.append(inputTarget.name, value)
      }
    })

    fetch(this.data.get("path"), {
      method: this.data.get("method"),
      credentials: "same-origin",
      body: data
    })
      .then(response => response.json())
      .then(response => {
        if (response.error) {
          alert(response.error)
        } else if (response.location) {
          window.location = response.location
        }
        e.target.disabled = false
      })
      .catch(error => {
        alert(error.error)
        e.target.disabled = false
      });
  }
}